module.exports = __webpack_public_path__ + "static/media/sun-logo.2361ca2e.png";